import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import axios from "axios";
// import { convertCurrency } from "../helper/CurrencyConverter";

const getCurrencySymbol = (currency) => {

  switch (currency) {

    case "INR":
      return "₹";

    case "USD":
      return "$";

    case "EUR":
      return "€";

    case "AED":
      return "AED ";

    case "SAR":
      return "SAR ";

    case "QAR":
      return "QAR ";

    case "GBP":
      return "£";

    default:
      return "$";
  }
};

const MAX_SWATCHES = 4;

/* ─── Single Product Card ─────────────────────────────────── */
const ProductCard = ({ item, selectedCurrency }) => {
  const variants = item.variants || [];

  const colorVariants = variants.filter(
    (v) => v.color || v.colorName || v.colorCode || v.colorHex
  );

  const hasColors = colorVariants.length > 0;
  const [activeIdx, setActiveIdx] = useState(-1);

  const activeVariant = activeIdx >= 0 ? colorVariants[activeIdx] : null;

  const displayImage =
    activeVariant?.images?.[0] ||
    activeVariant?.image ||
    item.images?.[0] ||
    "assets/images/thumbs/product-img1.png";

  const variantPrice =
  activeVariant?.price ||
  item?.variants?.[0]?.price ||
  item?.price ||
  {};

const displayPrice =
  typeof variantPrice === "object"
    ? (
        variantPrice?.[
          selectedCurrency
        ] ||
        variantPrice?.INR
      )
    : variantPrice || 0;

  const variantOldPrice =
  activeVariant?.oldPrice ||
  item?.variants?.[0]?.oldPrice ||
  item?.oldPrice ||
  null;

const displayOldPrice =
  typeof variantOldPrice === "object"
    ? (
        variantOldPrice?.[
          selectedCurrency
        ] ||
        variantOldPrice?.INR
      )
    : variantOldPrice;

  const reviews = item.reviews || [];
  const total   = reviews.length;
  const avg     =
    total > 0
      ? (reviews.reduce((s, r) => s + (r.ratings || 0), 0) / total).toFixed(1)
      : "0.0";

  const swatchColor = (v) =>
    v.colorHex || v.colorCode || v.color || v.colorName || "#ccc";

  const visibleSwatches = colorVariants.slice(0, MAX_SWATCHES);
  const extraCount      = colorVariants.length - MAX_SWATCHES;

  return (
    <div className="na-card">
      {/* Image */}
      <Link to={`/product-details/${item._id}`} className="na-card__thumb">
        <img src={displayImage} alt={item.name} className="na-card__img" />
      </Link>

      {/* Colour swatches */}
      {hasColors && (
        <div className="pl-swatches">
          {visibleSwatches.map((v, i) => (
            <button
              key={i}
              className={`pl-swatch ${activeIdx === i ? "pl-swatch--active" : ""}`}
              style={{ background: swatchColor(v) }}
              title={v.colorName || v.color || `Color ${i + 1}`}
              onClick={() => setActiveIdx(activeIdx === i ? -1 : i)}
              aria-label={`Select color ${v.colorName || i + 1}`}
            />
          ))}
          {extraCount > 0 && (
            <Link to={`/product-details/${item._id}`} className="pl-swatch-more">
              +{extraCount}
            </Link>
          )}
        </div>
      )}

      {/* Content */}
      <div className="na-card__content">
        <h6 className="na-card__name">
          <Link to={`/product-details/${item._id}`} title={item.name}>
            {item.name}
          </Link>
        </h6>

        <div className="na-card__rating">
          <span className="pl-rating__avg">{avg}</span>
          <span className="pl-rating__star"><i className="ph-fill ph-star" /></span>
          <span className="pl-rating__count">({total})</span>
        </div>

       <div className="na-card__price">

  {displayOldPrice && (
    <span className="pl-price--old">

      {getCurrencySymbol(
        selectedCurrency
      )}

      {Number(
        displayOldPrice
      ).toFixed(2)}

    </span>
  )}

  <span className="pl-price--now">

    {getCurrencySymbol(
      selectedCurrency
    )}

    {Number(
      displayPrice
    ).toFixed(2)}

    <span className="na-qty">
      {" "} /Qty
    </span>

  </span>

</div>
      </div>
    </div>
  );
};

/* ─── Arrow components ────────────────────────────────────── */
function SampleNextArrow({ className, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`${className} slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
    >
      <i className="ph ph-caret-right" />
    </button>
  );
}

function SamplePrevArrow({ className, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`${className} slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
    >
      <i className="ph ph-caret-left" />
    </button>
  );
}

/* ─── Main Component ───────────────────────────────────────── */
const NewArrivalOne = ({ selectedCurrency }) => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/product/all`);
        if (res.data && res.data.success) {
          const sorted = res.data.data.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          setProducts(sorted.slice(0, 30));
        }
      } catch (err) {
        console.error("NewArrivalOne: fetch error", err);
      }
    };
    fetchProducts();
  }, []);

  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      { breakpoint: 1599, settings: { slidesToShow: 6 } },
      { breakpoint: 1399, settings: { slidesToShow: 4 } },
      { breakpoint: 992,  settings: { slidesToShow: 3, arrows: false, dots: false } },
      { breakpoint: 768,  settings: { slidesToShow: 2, arrows: false, dots: false } },
      { breakpoint: 575,  settings: { slidesToShow: 2, arrows: false, dots: false } },
      { breakpoint: 480,  settings: { slidesToShow: 1, arrows: false, dots: false } },
      { breakpoint: 424,  settings: { slidesToShow: 1, arrows: false, dots: false } },
    ],
  };

  return (
    <section className="new-arrival pb-80 mt-22">
      <div className="container container-lg">

        {/* Header */}
        <div className="section-heading flex-between flex-wrap gap-8">
          <h5 className="mb-0">New Arrivals</h5>
          <div className="flex-align mr-point gap-16">
            <Link
              to="/shop"
              className="text-sm fw-medium text-gray-900 hover-text-main-600 hover-text-decoration-underline"
            >
              View All Deals
            </Link>
          </div>
        </div>

        {/* Slider */}
        <div className="new-arrival__slider arrow-style-two mt-16">
          <Slider {...settings}>
            {products.length === 0 ? (
              <div className="px-16">
                <div className="na-card">
                  <p className="mb-0">No products found.</p>
                </div>
              </div>
            ) : (
              products.map((item) => (
                <div key={item._id} className="na-slide-wrap">
                  <ProductCard item={item} selectedCurrency={selectedCurrency} />
                </div>
              ))
            )}
          </Slider>
        </div>
      </div>

      <style>{`
        /* ══════════════════════════════════════
           Variables
           ══════════════════════════════════════ */
        .new-arrival {
          --pl-primary: var(--main-600, #1a8a3c);
          --pl-border:  #e3e6e8;
          --pl-radius:  12px;
          --pl-text:    #111;
          --pl-sub:     #565959;
          --pl-price:   #b12704;
        }

        /* ── Slide wrapper — gives breathing room between cards ── */
        .na-slide-wrap { padding: 0 6px; }

        /* ── Card ── */
        .na-card {
          background: #fff;
          border: 1px solid var(--pl-border);
          border-radius: var(--pl-radius);
          overflow: hidden;
          display: flex;
          flex-direction: column;
          transition: box-shadow .2s, border-color .2s;
        }
        .na-card:hover {
          box-shadow: 0 4px 16px rgba(0,0,0,0.11);
          border-color: #adb1b8;
        }

        /* ── Thumb ── */
        .na-card__thumb {
          display: block;
          width: 100%;
          height: 200px;
          overflow: hidden;
          background: #f9fafb;
        }
        .na-card__img {
          width: 100%; height: 100%;
          object-fit: cover;
          transition: transform .28s;
        }
        .na-card:hover .na-card__img { transform: scale(1.05); }

        /* ══════════════════════════════════════
           COLOUR SWATCHES  (shared class names
           with ProductListOne / RecommendedOne)
           ══════════════════════════════════════ */
        .pl-swatches {
          display: flex;
          align-items: center;
          gap: 5px;
          padding: 8px 10px 4px;
          flex-wrap: wrap;
        }
        .pl-swatch {
          width: 20px; height: 20px;
          border-radius: 50%;
          border: 2px solid transparent;
          outline: 2px solid transparent;
          cursor: pointer;
          padding: 0;
          transition: outline .15s, border .15s, transform .15s;
          flex-shrink: 0;
        }
        .pl-swatch:hover {
          transform: scale(1.18);
          outline: 2px solid #aaa;
          outline-offset: 1px;
        }
        .pl-swatch--active {
          border: 2px solid #fff;
          outline: 2px solid var(--pl-primary);
          outline-offset: 1px;
          transform: scale(1.12);
        }
        .pl-swatch-more {
          font-size: 11.5px;
          color: var(--pl-primary);
          font-weight: 600;
          text-decoration: none;
          white-space: nowrap;
          margin-left: 2px;
        }
        .pl-swatch-more:hover { text-decoration: underline; }

        /* Rating (shared) */
        .pl-rating__avg   { font-size: 12px; font-weight: 700; color: #555; }
        .pl-rating__star  { font-size: 13px; color: #f0a500; display: flex; }
        .pl-rating__count { font-size: 11.5px; color: var(--pl-sub); }

        /* Price (shared) */
        .pl-price--now { font-size: 15px; font-weight: 700; color: var(--pl-price); }
        .pl-price--old { font-size: 12px; color: #888; text-decoration: line-through; }

        /* ── Card content ── */
        .na-card__content {
          padding: 4px 10px 12px;
          display: flex; flex-direction: column; gap: 4px; flex: 1;
        }
        .na-card__name {
          margin: 0;
          font-size: 13.5px; font-weight: 600; line-height: 1.35;
        }
        .na-card__name a {
          color: var(--pl-text); text-decoration: none;
          display: -webkit-box;
          -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;
        }
        .na-card__name a:hover { color: var(--pl-primary); text-decoration: underline; }

        .na-card__rating { display: flex; align-items: center; gap: 3px; }

        .na-card__price {
          display: flex; align-items: baseline; flex-wrap: wrap; gap: 6px; margin-top: 2px;
        }
        .na-qty { font-size: 11px; color: var(--pl-sub); font-weight: 400; }

        /* ══════════════════════════════════════
           RESPONSIVE
           ══════════════════════════════════════ */
        @media (max-width: 991px) {
          .section-heading {
            width: 100%;
            display: flex !important;
            justify-content: space-between !important;
            align-items: center !important;
            flex-wrap: nowrap !important;
          }
          .new-arrival .mr-point {
            margin: 0 !important;
            display: flex !important;
            justify-content: flex-end !important;
            align-items: center !important;
          }
          .new-arrival__slider { width: 100% !important; }
          .slick-slide > div { margin: 0 auto !important; }

          .na-card__thumb { height: 160px; }
          .na-card__name  { font-size: 12.5px; }
          .pl-price--now  { font-size: 13px; }
          .na-card__rating{ display: none; }
          .pl-price--old  { display: none; }
        }

        @media (max-width: 575px) {
          .na-card__thumb  { height: 130px; }
          .na-card__content{ padding: 4px 7px 10px; }
          .na-card__name   { font-size: 11.8px; }
          .pl-price--now   { font-size: 12.5px; }
          .pl-swatch       { width: 16px; height: 16px; }
          .pl-swatches     { gap: 4px; padding: 6px 7px 2px; }
          .pl-swatch-more  { font-size: 10.5px; }
          .na-slide-wrap   { padding: 0 3px; }
        }
      `}</style>
    </section>
  );
};

export default NewArrivalOne;